module.exports = __webpack_public_path__ + "img/Identity.17ff90da.svg";